module.exports = __webpack_public_path__ + "img/clock.1fd2aa23.svg";